import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers/reducers';
import listenForRequests from '../sagas/sagas';

const middleware = [];
const sagaMiddleware = createSagaMiddleware();
middleware.push(sagaMiddleware);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (process.env.NODE_ENV === 'development') {
	const logger = createLogger();
	middleware.push(logger);
}
const enhancer = composeEnhancers(applyMiddleware(...middleware));

export function configureStore(initialState) {
	const store = createStore(rootReducer, initialState, enhancer);

	if (import.meta.hot) {
		import.meta.hot.accept('../reducers/reducers', (newModule) => {
			store.replaceReducer(newModule.default);
		});
	}
	sagaMiddleware.run(listenForRequests);

	return store;
}
